interface VinylGeometry {
  radius: number;
  angleRad: number;
  angleDeg: number;
}

export const calculateVinylGeometry = (
  cardHeight: number,
  carouselRadius: number,
): VinylGeometry => {
  const radius = Math.max(carouselRadius, 1);
  if (cardHeight > 0 && carouselRadius > 0) {
    const angleRad = Math.atan2(cardHeight / 2, carouselRadius);
    const angleDeg = (angleRad * 180) / Math.PI;
    return { radius, angleRad, angleDeg };
  }
  return { radius, angleRad: 0, angleDeg: 0 };
};
